function SocialPatreonIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      fill="currentcolor"
    >
      <path d="M24 12c0 6.63-5.37 12-12 12S0 18.63 0 12 5.37 0 12 0s12 5.37 12 12Zm-9.491-7A5.515 5.515 0 0 0 9 10.508C9 13.536 11.471 16 14.509 16A5.498 5.498 0 0 0 20 10.508C20 7.471 17.537 5 14.509 5M6 19h2V5H6v14Z" />
    </svg>
  );
}

export default SocialPatreonIcon;
